export class NoopStorage {
  clear() { }
  getItem(key) { return null }
  removeItem(key) { }
  setItem(key, data) { }
}